export default {
    items: {
        data: null
    },
    imagens: {
        data: null
    }
}